import { EventId } from "#clockwise/web-commons/src/util/ActiveEventContext";

export const encode = (toEncode: EventId) => btoa(JSON.stringify(toEncode));

export const decode = (toDecode: string) => {
  try {
    const parsed = JSON.parse(atob(toDecode)) as object;
    if (isValid(parsed)) {
      return parsed as EventId;
    } else {
      return Error("Invalid object");
    }
  } catch (e: any) {
    return Error("Unable to decode", e);
  }
};

export const isValid = (object: object) =>
  !!(
    object &&
    Object.prototype.hasOwnProperty.call(object, "calendarId") &&
    Object.prototype.hasOwnProperty.call(object, "externalEventId")
  );
